import React, { Component, Fragment } from 'react';
import ReactDOM from 'react-dom';
import { HashRouter as Router, Route, Redirect, Switch } from 'react-router-dom';
import { DragDropContextProvider } from 'react-dnd';
import HTML5Backend from 'react-dnd-html5-backend';
import DefaultLayout from './containers/DefaultLayout/DefaultLayout.js';
import moment from 'moment';

import './App.scss';

ReactDOM.render(
     <DragDropContextProvider backend={HTML5Backend}>
          <Router>
               <Switch>
                    <Route path="/" name="Home" component={DefaultLayout} />
               </Switch>
          </Router>
     </DragDropContextProvider>,
     document.getElementById('root')
);



// WEBPACK FOOTER //
// ./src/index.js